import React from 'react'

export function Header({ theme, onToggleTheme, onRefresh, lastRefresh }) {
  // Navigation lives in the Sidebar only. The header previously duplicated it
  // as a 9-tab bar whose extra 5 entries (pipeline/scope/coverage/security/
  // performance) had no matching view in App.jsx at all -- clicking them
  // rendered a blank content area.
  return (
    <header className="header" role="banner">
      <div className="header-left">
        <button className="menu-toggle" aria-label="Toggle sidebar" onClick={() => window.dispatchEvent(new CustomEvent('sidebar-toggle'))}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <div className="logo">
          <span className="logo-icon">🤖</span>
          <span className="logo-text">ESSMS AI Audit</span>
        </div>
      </div>
      <div className="header-right">
        <div className="refresh-indicator">
          <span className="refresh-dot" style={{ animation: 'pulse 2s infinite' }} />
          <span className="refresh-text">Updated {new Date(lastRefresh).toLocaleTimeString()}</span>
          <button className="refresh-btn" onClick={onRefresh} aria-label="Refresh data">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M23 4v6h-6"></path>
              <path d="M1 20v-6h6"></path>
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
          </button>
        </div>
        <button className="theme-toggle" onClick={onToggleTheme} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
          {theme === 'light' ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
          )}
        </button>
      </div>
      <style jsx>{`
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 60px;
          padding: 0 24px;
          background: var(--surface-1);
          border-bottom: 1px solid var(--border);
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .menu-toggle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          color: var(--text-secondary);
        }
        .menu-toggle:hover {
          background: var(--page-plane);
          color: var(--text-primary);
        }
        .logo {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .logo-icon {
          font-size: 22px;
        }
        .logo-text {
          font-weight: 600;
          font-size: 16px;
          color: var(--text-primary);
        }
        .header-right {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .refresh-indicator {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          color: var(--text-muted);
        }
        .refresh-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: var(--status-good);
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .refresh-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border-radius: 6px;
          color: var(--text-secondary);
        }
        .refresh-btn:hover {
          background: var(--page-plane);
          color: var(--text-primary);
        }
        .theme-toggle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          color: var(--text-secondary);
        }
        .theme-toggle:hover {
          background: var(--page-plane);
          color: var(--text-primary);
        }
      `}</style>
    </header>
  )
}